<ng-container>

    <div [ngClass]="searchOptionState == 'hide' ? 'buttons-container bg-th-blue p-2' : 'buttons-container' ">

        <div class="row gx-2 gy-2 pt-2 align-items-center position-sticky">

            <!-- فرم جستجوی خودروها -->

            <div [ngClass]="searchOptionState == 'hide' ? '' : 'p-2' " [@slideDown]="searchOptionState">

                <div [formGroup]="mdlSearch" class="bg-white" style="direction: rtl;">

                    <div class="row gx-3 gy-3 p-2">

                        <!-- نوع کاربری -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted"> نوع کاربری </label>

                            <select class="form-select p-2" formControlName="tiMobileUsage">

                                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_MobileUsage"
                                    value="{{item.tiMobileUsage}}">

                                    {{item.strComment}}

                                </option>

                            </select>

                        </div>

                        <!-- گروه خودرویی -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted"> گروه خودرویی </label>

                            <select class="form-select p-2" formControlName="tiMobileGroup">

                                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_MobileGroup"
                                    value="{{item.tiMobileGroup}}">

                                    {{item.strComment}}

                                </option>

                            </select>

                        </div>

                        <!-- نوع خودرو -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted"> نوع خودرو </label>

                            <select class="form-select p-2" formControlName="tiMobileType">

                                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of carWork" value="{{item.tiMobileType}}">

                                    {{item.strComment}}

                                </option>

                            </select>

                        </div>

                        <!-- برند خودرو -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted"> برند خودرو </label>

                            <select class="form-select p-2" formControlName="tiGPSType">

                                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of carType" [value]="item.tiGPSType">

                                    {{item.strComment}}

                                </option>

                            </select>

                        </div>

                        <!-- نوع ردیاب -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="text-muted"> نوع ردیاب </label>

                            <custom-filter *ngIf="showFilter"
                                [strValue]="returnStrValue('iGPS',mdlSearch.get('iGPS')?.value,gpsType,'strComment')"
                                [strComment]="'strComment'" [stylesArray]="['padding-top: 10px','text-align: center']"
                                [str_Placeholder]="' انتخاب کنید '" [lst_Main]="gpsType"
                                [lst_SearchKey]="['strComment']" [isDisabled]="mdlSearch.disabled ? true : false"
                                (hideOptions)="mdlSearch.get('iGPS')?.setValue($event?.iGPS ? $event.iGPS : '-1')">

                            </custom-filter>

                        </div>

                        <!-- حوزه خدمت -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted"> حوزه خدمت </label>

                            <select class="form-select p-2" formControlName="iMobileDomain">

                                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_MobileDomain"
                                    [value]="item.iMobileDomain">

                                    {{item.strComment}}

                                </option>

                            </select>

                        </div>

                        <!-- نوع سوخت -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted"> نوع سوخت </label>

                            <select class="form-select" formControlName="tiFuelType">

                                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                                <option class="text-center" [value]="0"> ندارد</option>

                                <option class="text-center" [value]="1"> بنزین </option>

                                <option class="text-center" [value]="2"> نفت گاز </option>

                                <option class="text-center" [value]="3"> هیبرید </option>

                                <option class="text-center" [value]="4"> برقی </option>

                            </select>

                        </div>

                        <!-- ظرفیت خودرو -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted"> ظرفیت خودرو </label>

                            <input class="form-control p-2 text-center"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')" formControlName="tiPassenger">

                        </div>

                        <!-- تیپ خودرو -->

                        <div class="position-relative col-12 col-md-2 p-2">

                            <label class="mb-2 text-muted"> تیپ خودرو </label>

                            <input class="form-control p-2 text-center" formControlName="strVehicleType">

                        </div>

                        <!-- نام راننده -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted"> نام راننده </label>

                            <input class="form-control p-2 text-center" formControlName="strFullName">

                        </div>

                        <!-- سیم کارت ردیاب -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted"> سیم کارت ردیاب </label>

                            <input class="form-control p-2 text-center" formControlName="strCellNo">

                        </div>

                        <!-- موبایل راننده -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted"> موبایل راننده </label>

                            <input class="form-control p-2 text-center" formControlName="strMobile">

                        </div>

                        <!-- شناسه دستگاه -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted"> شناسه دستگاه </label>

                            <input class="form-control p-2 text-center" formControlName="strUnitID">

                        </div>

                        <!-- نوع پلاک -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted"> نوع پلاک </label>

                            <select class="form-select p-2" formControlName="tiPlateType">

                                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                                <option class="text-center" *ngFor="let item of lst_Plate" value="{{item.tiPlateType}}">

                                    {{item.strComment}}

                                </option>

                            </select>

                        </div>

                        <!-- پلاک -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted"> پلاک </label>

                            <input class="form-control p-2 text-center" formControlName="strVehicleNo">

                        </div>

                        <!-- شماره پرسنلی -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted"> شماره پرسنلی </label>

                            <input class="form-control p-2 text-center" formControlName="strPersonnelID">

                        </div>

                        <!-- از کیلومتر -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted"> از کیلومتر </label>

                            <input class="form-control p-2 text-center" formControlName="iSKm">

                        </div>

                        <!-- تا کیلومتر -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted"> تا کیلومتر </label>

                            <input class="form-control p-2 text-center" formControlName="iEKm">

                        </div>

                        <!-- از سال ساخت -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted"> از سال ساخت </label>

                            <input class="form-control p-2 text-center" maxlength="4"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="iSYearConstruction">

                        </div>

                        <!-- تا سال ساخت -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted"> تا سال ساخت </label>

                            <input class="form-control p-2 text-center" maxlength="4"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="iEYearConstruction">

                        </div>

                        <!-- از زمان فعالیت -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted" style="z-index: 10;"> از زمان فعالیت </label>

                            <div class="input-group clockpicker">

                                <input autocomplete="off" class="form-control p-2 text-center" id="strSTime"
                                    formControlName="strSTime">

                                <span class="input-group-addon">

                                    <span class="glyphicon glyphicon-time"></span>

                                </span>

                            </div>

                        </div>

                        <!-- تا زمان فعالیت -->

                        <div class="col-12 col-md-2 position-relative">

                            <label class="mb-2 text-muted" style="z-index: 10;"> تا زمان فعالیت </label>

                            <div class="input-group clockpicker">

                                <input autocomplete="off" class="form-control p-2 text-center" id="strETime"
                                    formControlName="strETime">

                                <span class="input-group-addon">

                                    <span class="glyphicon glyphicon-time"></span>

                                </span>

                            </div>

                        </div>

                        <!-- جستجو -->

                        <div class="col-12 col-md-auto">

                            <button class="btn btn-primary w-100 h-100" (click)="searchCar()">

                                &nbsp; جستجو &nbsp;

                            </button>

                        </div>

                        <!-- جمع شدن -->

                        <div class="col-12 col-md-auto">

                            <button class="btn btn-outline-danger w-100 h-100" (click)="toggleSearchOption()">

                                &nbsp; جمع شدن &nbsp;

                            </button>

                        </div>

                        <!-- بازگشت -->

                        <div class="col-12 col-md-auto">

                            <button class="btn btn-secondary w-100 h-100" [routerLink]="['/']">

                                &nbsp; بازگشت &nbsp;

                            </button>

                        </div>

                    </div>

                </div>

            </div>

            <!-- دکمه های هدر -->

            <ng-container *ngIf="searchOptionState == 'hide' ">

                <div class="col-12 col-md-12 row gx-2 ">

                    <div class="col-2 col-md-auto p-1">

                        <button class="w-100 btn btn-secondary pointer" [routerLink]="['/']">

                            <i class="fa fa-arrow-left"></i>&nbsp;

                        </button>

                    </div>

                    <div *ngIf="!bSimpleSearch" class="col-12 col-md-auto p-1">

                        <button class="w-100 btn btn-primary pointer" (click)="toggleSearchOption()">

                            <i class="fa fa-filter" aria-hidden="true"></i>&nbsp;

                            فیلتر

                        </button>

                    </div>

                    <div class="col-12 col-md-auto p-1">

                        <button class="w-100 btn btn-success pointer" (click)="exportexcel('excel-car-list')">

                            <i class="fa fa-file-excel-o"></i>&nbsp; اکسل

                        </button>

                    </div>

                    <div class="col-12 col-md-auto p-1" *ngIf="bEnableEditCar">

                        <button class="w-100 btn btn-danger pointer" (click)="updateMobileDomain()">

                            <i class="fa fa-university"></i>&nbsp; حوزه خدمتی

                        </button>

                    </div>

                    <div class="col-12 col-md-auto p-1" *ngIf="bSendSMS">

                        <button class="w-100 btn btn-warning pointer" (click)="openSMS_User()">

                            <i class="fa fa-envelope"></i>&nbsp; فرمان به دستگاه

                        </button>

                    </div>

                    <div class="col-12 col-md-auto p-1" *ngIf="bSendPush">

                        <button class="w-100 btn btn-primary pointer" (click)="openPush_User()">

                            <i class="fa fa-envelope"></i>&nbsp; پیام به راننده

                        </button>

                    </div>

                    <div class="col-12 col-md-auto p-1" (click)="showAll_Map()">

                        <button class="w-100 btn pointer text-white" style="background-color: #475569;">

                            <i class="fa fa-map-marker fa-lg"></i>

                            &nbsp; نمایش

                        </button>

                    </div>

                    <div class="col-12 col-md-auto p-1">

                        <button class="w-100 btn pointer text-white" style="background-color: #9f1239;">

                            <i class="fa fa-users fa-lg"></i>

                            &nbsp; استعلام گروهی خلافی

                        </button>

                    </div>

                    <div class="col-12 col-md-auto p-1">

                        <button class="w-100 btn btn-success pointer">

                            <i class="fa fa-car fa-lg"></i>

                            &nbsp; گزارش خودروهای دولتی

                        </button>

                    </div>

                    <div class="col-12 col-md-auto p-1" *ngIf="bUpdate_ValidDate">

                        <button class="w-100 btn btn-secondary pointer" (click)="showUpdate_Modal()">

                            <i class="fa fa-credit-card fa-lg"></i>

                            &nbsp; ویرایش اعتبار

                        </button>

                    </div>

                </div>

                <div class="col-12 text-start ">

                    <span class="text-center text-white"> تعداد خودروها :

                        <strong class="blueText">{{carNumber.toLocaleString() | faNum}}</strong>

                        مورد

                    </span>

                </div>

            </ng-container>

        </div>

    </div>

    <!-- جستجو -->

    <ng-container *ngIf="searchOptionState == 'hide' ">

        <div class="bg-th-blue py-2 position-sticky top-0">

            <div class="container-fluid col-12 d-flex justify-content-between" [formGroup]="serchModel">

                <div class="col-12">

                    <div class=" d-flex justify-content-end">

                        <div class="w-100">

                            <div class="search">

                                <i class="fa fa-search icon-serch"></i>

                                <input class="form-control" formControlName="txt"
                                    placeholder="بر اساس نام راننده / حوزه خدمت / شناسه دستگاه / شماره پرسنلی / پلاک / سیمکارت ردیاب جستجو کنید ..."
                                    (input)="serch()">

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </ng-container>

    <!-- حالت موبایل -->

    <div class="d-flex justify-content-around flex-wrap" *ngIf="!deviceInfo">

        <div class="container shadow bg-light rounded mt-2 py-2 col-md-5 col-11" *ngFor="let item of filterCar"
            [routerLink]="['/carInfo/',item.strUnitID]">

            <div class="d-flex justify-content-between">

                <div>

                    <i class="fa fa-circle text-secondary" *ngIf="!item.bOnline"></i>

                    <i class="fa fa-circle text-success" *ngIf="item.bOnline"></i>

                </div>

                <div class="">

                    <span>{{item.strFullName}}</span>

                    <div *ngIf="item.strIconName">

                        <img src="../../../assets/mobile-icons/{{item.strIconName}}">

                    </div>

                </div>

            </div>

            <div class="d-flex justify-content-between mt-2">

                <div class=" text-start flex-column col-6 br-end">

                    <p class="ps-2 m-0">سرعت: {{item.iSpeed}}</p>

                    <p class="ps-2 m-0">ساعت: {{item.strTime |faNum}}</p>

                </div>

                <div class=" text-start flex-column br-end col-6">

                    <p class="ps-2 m-0">پلاک: {{item.strVehicleNo}}</p>

                    <p class="ps-2 m-0">تاریخ: {{item.strDate |faNum}}</p>

                </div>

            </div>

        </div>

    </div>

    <div class="section border border-2" #scrollContainer>

        <table class="table mt-1 dirI table-striped" *ngIf="deviceInfo " id="excel-car-list">

            <thead class=" dirI ">

                <tr class="text-center">

                    <th scope="col" class=""># </th>

                    <th *ngIf="bTaxiLon" scope="col" class=""> عملیات </th>

                    <th scope="col" class="pointer" *ngIf="bEnableEditCar" (click)="onCheckbox_Car('','','select-all')">
                        انتخاب </th>

                    <th scope="col" class="">وضعیت </th>

                    <th scope="col" class="">فعال </th>

                    <th scope="col" class="pointer" (click)="sortBy(1)">

                        <i class="fa fa-sort" aria-hidden="true"></i>

                        &nbsp;راننده

                    </th>

                    <th scope="col" class="">شماره</th>

                    <th scope="col" class="">VIN</th>

                    <th scope="col" class="">تیپ</th>

                    <th scope="col" class="">پلاک</th>

                    <th scope="col" class="">کد شناسایی </th>

                    <th scope="col" class="pointer" (click)="sortBy(3)">

                        <i class="fa fa-sort" aria-hidden="true"></i>

                        &nbsp; پایان اعتبار

                    </th>

                    <th scope="col" class="pointer" (click)="sortBy(5)">

                        <i class="fa fa-sort" aria-hidden="true"></i>

                        &nbsp; آخرین سابقه

                    </th>

                    <th scope="col" class="">موبایل راننده</th>

                    <th scope="col" class="pointer" (click)="sortBy(4)">

                        <i class="fa fa-sort" aria-hidden="true"></i>

                        &nbsp;حوزه خدمت

                    </th>

                    <th scope="col" class="">نوع خودرو</th>

                    <th scope="col" class="">سیم کارت</th>

                    <th scope="col" class="pointer" (click)="sortBy(0)">

                        <i class="fa fa-sort" aria-hidden="true"></i>

                        &nbsp; شماره پرسنلی

                    </th>

                    <th scope="col" class="pointer" (click)="sortBy(2)">

                        <i class="fa fa-sort" aria-hidden="true"></i>

                        &nbsp; تاریخ ثبت

                    </th>

                </tr>

            </thead>

            <tbody>

                <tr class="text-center hoverItem pointer dirI f14" *ngFor="let item of filterCar;let i=index"
                    (click)="changeRoute(item)">

                    <th class="text-dark">{{i+1 | faNum}}</th>

                    <th *ngIf="bTaxiLon" class="text-dark">

                        <i class="fa fa-car fa-lg mx-2 text-success pointer" title="برنامه راننده"
                            (click)="open_AssignModal($event,item)"></i>

                    </th>

                    <th *ngIf="bEnableEditCar" class="text-dark">

                        <input type="checkbox" [checked]="item?.bChosen" (click)="onCheckbox_Car($event,i)">
                    </th>

                    <th>

                        <i class="fa fa-circle" [ngClass]="item.bOnline ? 'text-success' : 'text-danger' ">

                        </i>

                    </th>

                    <th>

                        <i class="fa fa-circle" [ngClass]="item.bActive ? 'text-success' : 'text-danger' ">

                        </i>

                    </th>

                    <th class="text-dark">{{item.strFullName2}}</th>

                    <th class="text-dark">{{item.iCode | faNum}}</th>

                    <th class="text-dark">{{item.strVIN | faNum}}</th>

                    <th class="text-dark">{{item.strVehicleType}}</th>

                    <th>

                        {{ item.strVehicleNo ? otherService.returnCorrectPlate(item.strVehicleNo) : '' | faNum}}

                    </th>

                    <th class="text-dark">{{item.strUnitID|faNum}}</th>

                    <th class="text-dark">{{item.strValidDate|faNum}}</th>

                    <th class="text-darkdirI">{{item.strTime|faNum}} - {{item.strDate|faNum}}</th>

                    <th class="text-dark">{{item.strMobile|faNum}}</th>

                    <th class="text-dark">{{item.strMobileDomain_strComment}}</th>

                    <th class="text-dark">{{item.strMobileType_strComment}}</th>

                    <th class="text-dark">{{item.strCellNo|faNum}}</th>

                    <th class="text-dark">{{item.strPersonnelID|faNum}}</th>

                    <th class="text-dark">{{item.strDefinationDate|faNum}}</th>

                </tr>

            </tbody>

        </table>

    </div>

    <!--ارسال پیامک-->

    <div class="modal fade" id="SmsModal" tabindex="-1" aria-labelledby="" aria-hidden="true">

        <div class="modal-dialog modal-dialog-centered">

            <div class="modal-content">

                <div class="modal-header">

                    <button type="button" class="btn-close " data-bs-dismiss="modal" aria-label="Close"></button>

                    <h5 class="modal-title  ms-0" id=""> پیام به دستگاه </h5>

                </div>

                <div class="modal-body" [formGroup]="mdl_SMS">

                    <!-- متن پیام -->

                    <div class="col-12">

                        <textarea style="height: 20px;resize: none;"
                            [ngClass]="mdl_SMS.get('strSMS')?.value != '' ? 'text-end' : 'text-start' "
                            formControlName="strSMS" placeholder="متن پیام خود را وارد کنید" class="form-control">

                        </textarea>

                    </div>

                    <!-- GPRS/SMS -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bGPRS" formControlName="bGPRS">

                        <label class="form-check-label pointer text-muted me-2" for="bGPRS">

                            {{ mdl_SMS.get('bGPRS')?.value ? 'GPRS' : 'SMS' }}

                        </label>

                    </div>

                </div>

                <div class="modal-footer">

                    <button type="button" class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#carModal">

                        بستن

                    </button>

                    <button type="button" class="btn btn-primary" (click)="sendSMS_4Users()">

                        {{ mdl_SMS.get('bGPRS')?.value ? 'GPRS ارسال' : 'SMS ارسال' }}

                    </button>

                </div>

            </div>

        </div>

    </div>

    <!-- ارسال پوش -->

    <div class="modal fade" id="Push_Modal" tabindex="-1" aria-labelledby="" aria-hidden="true">

        <div class="modal-dialog modal-dialog-centered">

            <div class="modal-content">

                <div class="modal-header">

                    <button type="button" class="btn-close " data-bs-dismiss="modal" aria-label="Close"></button>

                    <h5 class="modal-title  ms-0"> ارسال پیام به راننده </h5>

                </div>

                <div class="modal-body" [formGroup]="mdl_PUSH">

                    <ng-container *ngIf="mdl_PUSH.get('iPushType')?.value == 0">

                        <div class="row gx-0 gy-0">

                            <div class="col-12 col-md-6 px-2" (click)="mdl_PUSH.get('iPushType').setValue('2')">

                                <div
                                    class="pointer bg-success w-100 p-1 py-2 d-flex flex-column justify-content-center align-items-center border border-2">

                                    <span class="text-white"> صدا </span>

                                    <i class="fa fa-microphone fa-lg my-2 text-white" aria-hidden="true"></i>

                                </div>

                            </div>

                            <div class="col-12 col-md-6 px-2" (click)="mdl_PUSH.get('iPushType').setValue('1')">

                                <div
                                    class="pointer bg-primary  w-100 p-1 py-2 d-flex flex-column justify-content-center align-items-center border border-2">

                                    <span class="text-white"> پیام </span>

                                    <i class="fa fa-envelope-o fa-lg text-white my-2" aria-hidden="true"></i>

                                </div>

                            </div>

                        </div>

                    </ng-container>

                    <!-- متن -->

                    <ng-container *ngIf="mdl_PUSH.get('iPushType')?.value == 1">

                        <!-- عنوان -->

                        <div class="position-relative col-12 p-2">

                            <label class="mb-2 text-muted" style="top: -5px;"> عنوان </label>

                            <input class="form-control p-2 text-center" formControlName="strTitle">

                        </div>

                        <!-- متن پیام -->

                        <div class="col-12 p-2">

                            <textarea style="height: 120px;resize: none;" formControlName="strMessage"
                                placeholder="متن پیام خود را وارد کنید" class="form-control">

                            </textarea>

                        </div>

                        <!-- ارسال پیامک -->

                        <div class="col-12 p-2" *ngIf="bSendPayamak">

                            <div class="form-check form-switch m-0 d-flex align-items-center col-12 px-2">

                                <input class="form-check-input m-0" type="checkbox" id="bSMS" formControlName="bSMS">

                                <label class="form-check-label pointer text-muted me-2" for="bSMS"> پیامک </label>

                            </div>


                        </div>

                    </ng-container>

                    <!-- صدا -->

                    <ng-container *ngIf="mdl_PUSH.get('iPushType')?.value == 2">

                        <div class="col-12 p-2">

                            <!-- عنوان -->

                            <div class="position-relative col-12 p-2">

                                <label class="mb-2 text-muted" style="top: -5px;"> عنوان </label>

                                <input class="form-control p-2 text-center" formControlName="strTitle">

                            </div>

                        </div>

                        <div class="col-12 p-2">

                            <!-- start Recording -->

                            <ng-container *ngIf="!isAudioRecording && !isAudioRecorded()">

                                <button class="btn btn-secondary w-100" (click)="startAudioRecording()">

                                    <i class="fa fa-microphone me-1" aria-hidden="true"></i>

                                    <span class="text-warning"> {{ '*' }} </span>

                                    ضبط صدا

                                    <span> {{ '( اجباری )' }} </span>

                                </button>

                            </ng-container>

                            <!-- stop Recording -->

                            <ng-container *ngIf="isAudioRecording && !isAudioRecorded()">

                                <button class="btn btn-secondary w-100" (click)="stopAudioRecording()">

                                    <i class="fa fa-square me-1" aria-hidden="true"></i>

                                    توقف صدا

                                    <span> {{ audioRecordedTime | faNum }} </span>

                                </button>

                            </ng-container>

                            <!-- play Recording -->

                            <ng-container *ngIf="!isAudioRecording && isAudioRecorded()">

                                <div class="position-relative">

                                    <div class="audio-icon col-2" *ngIf="isAudioRecorded()">

                                        <button class="btn" style="background: #F1F3F4;"
                                            (click)="clearAudioRecordedData()">

                                            <i class="fa fa-trash fa-lg" aria-hidden="true"></i>

                                        </button>

                                    </div>

                                    <div *ngIf="audioSrcUrl != ''">

                                        <audio controls class="w-100 rounded">

                                            <source [src]="audioSrcUrl" type="audio/mp3">

                                            Your browser does not support the audio element.

                                        </audio>

                                    </div>

                                </div>

                            </ng-container>

                        </div>

                    </ng-container>

                </div>

                <div class="modal-footer">

                    <ng-container *ngIf="mdl_PUSH.get('iPushType')?.value != 0">

                        <button class="btn btn-outline-danger" (click)="mdl_PUSH.get('iPushType').setValue('0')">

                            بازگشت

                        </button>

                        <button type="button" class="btn btn-primary" (click)="sendPush_4Users()">

                            ارسال

                        </button>

                    </ng-container>

                </div>

            </div>

        </div>

    </div>

    <!-- مدال اختصاص خودرو براساس برنامه -->

    <div class="modal fade" id="assignModal" tabindex="-1">

        <div class="modal-dialog modal-xl">

            <div class="modal-content dirI">

                <div class="modal-header dirI">

                    <h5 class="modal-title" id="exampleModalLabel"> برنامه راننده </h5>

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                </div>

                <div class="modal-body">

                    <div class="col-12 section border border-2 mt-2"
                        style="max-height:calc(100vh - 270px);overflow: auto;">

                        <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                            <thead class="">

                                <tr class="">

                                    <th class="text-center col-1"> # </th>

                                    <th class="text-center col-1"> تاریخ </th>

                                    <th class="text-center"> ساعت </th>

                                    <th class="text-center"> شهر مبداء </th>

                                    <th class="text-center"> گروه خودرویی </th>

                                    <th class="text-center"> نام خودرو </th>

                                    <th class="text-center"> نوع خودرو </th>

                                    <th class="text-center"> مدل خودرو </th>

                                    <th class="text-center"> نام راننده </th>

                                    <th class="text-center"> موبایل </th>

                                    <th class="text-center"> سفر&zwnj;ها </th>

                                    <th class="text-center"> لغو&zwnj;ها </th>

                                </tr>

                            </thead>

                            <tbody class="">

                                <tr class="col-12 text-center" *ngFor="let item of lst_TaxiLon_Driver;let i = index">

                                    <td>{{ i + 1 | faNum }}</td>

                                    <td> {{ item.strDate | faNum }} </td>

                                    <td> {{ item.strSTime | faNum }} </td>

                                    <td> {{ item.strCityName | faNum }} </td>

                                    <td> {{ item.strMobileGroup_strComment | faNum }} </td>

                                    <td> {{ item.strGPSType_strComment | faNum }} </td>

                                    <td> {{ item.strMobileType_strComment | faNum }} </td>

                                    <td> {{ item.iYearConstruction | faNum }} </td>

                                    <td> {{ item.strFullName | faNum }} </td>

                                    <td> {{ item.strMobile | faNum }} </td>

                                    <td> {{ item.iTrip | faNum }} </td>

                                    <td> {{ item.iCancel | faNum }} </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>

                <div class="modal-footer d-flex justify-content-start">

                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                        &nbsp; بستن &nbsp;

                    </button>

                </div>

            </div>

        </div>

    </div>

    <!-- Validity_Modal -->

    <div class="modal fade" id="Validity_Modal" tabindex="-1">

        <div class="modal-dialog modal-md">

            <div class="modal-content dirI">

                <div class="modal-header dirI">

                    <h5 class="modal-title" id="exampleModalLabel"> ویرایش اعتبار </h5>

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                </div>

                <div class="modal-body">

                    <div [formGroup]="mdl_UpdateValidDate" class="container-fluid row gx-2 gy-2 p-2">

                        <!-- تاریخ پایان اعتبار -->

                        <div class="position-relative col-12 col-md-6 p-2">

                            <label class="text-muted" style="top: -6px;"> تاریخ پایان اعتبار </label>

                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                                [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="true"
                                [dateFormat]="'jYYYY/jMM/jDD'">

                                <input type="text" formControlName="strValidDate" class="form-control text-end" />

                            </ng-persian-datepicker>

                        </div>

                        <!-- مبلغ اعتبار (ریال) -->

                        <div class="position-relative col-12 col-md-6 p-2">

                            <label class="text-muted" style="top: -6px;"> مبلغ اعتبار (ریال) </label>

                            <input class="form-control text-center"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                formControlName="iChargingFee">

                        </div>

                    </div>

                </div>

                <div class="modal-footer d-flex justify-content-start">

                    <button class="btn btn-success" (click)="submit_Validity()">

                        &nbsp; تمدید &nbsp;

                    </button>

                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                        &nbsp; بستن &nbsp;

                    </button>

                </div>

            </div>

        </div>

    </div>

</ng-container>